import React, { Component } from 'react';

// Components
import SeriesTable from "../../../components/common/SeriesTable";

class SaleDocuments extends Component {
    render() {
        return (
            <div className="panel-body">
                <h2>Facturas de venta</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.salesInvoicesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Albaranes de venta</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.issuesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Pedidos de venta</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.salesOrdersSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Presupuestos de venta</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.quotesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Escandallos de venta</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.costBreakdownsSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Clientes</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.customersSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SaleDocuments;


// WEBPACK FOOTER //
// ./src/containers/configuration/documents/SaleDocuments.js